import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fetchClient, formatHeaders } from '@nike/fetch-client';
import { CARTS_BASE_PATH } from '@nike/cart-constants';
import { DOTCOM_UX_ID, NIKECOM_CHANNEL, NIKE_BRAND } from '@nike/ux-tread-dotcom-constants';
import getWebShellClientLocale from "../../../../../utils/get-webshellclient-locale";
/**
 * patchCart - adds or removes a line item or promotion code from a user’s cart
 * using filters in url path
 *
 * @param {object} params - named parameters for clarity
 * @param {object} params.fetchOptions - options to pass down to fetch
 * @param {Array} [params.actions=[]] - Array of operation objects
 * @returns {Promise} fetch promise
 */
var patchCart = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var _getWebShellClientLoc;
    var _ref$actions, actions, fetchOptions, token, _yield$window$webShel, visitorId, visitId, country, brand, channel;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$actions = _ref.actions, actions = _ref$actions === void 0 ? [] : _ref$actions, fetchOptions = _ref.fetchOptions;
          _context.next = 1;
          return window.webShellClient.identity.getAccessToken();
        case 1:
          token = _context.sent;
          _context.next = 2;
          return window.webShellClient.identity.getVisitData();
        case 2:
          _yield$window$webShel = _context.sent;
          visitorId = _yield$window$webShel.visitorId;
          visitId = _yield$window$webShel.visitId;
          country = (_getWebShellClientLoc = getWebShellClientLocale().country) === null || _getWebShellClientLoc === void 0 ? void 0 : _getWebShellClientLoc.toUpperCase();
          brand = NIKE_BRAND;
          channel = NIKECOM_CHANNEL;
          return _context.abrupt("return", fetchClient("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/").concat(CARTS_BASE_PATH, "/").concat(country, "/").concat(brand, "/").concat(channel, "?modifiers=VALIDATELIMITS,VALIDATEAVAILABILITY"), _objectSpread({
            headers: formatHeaders({
              token: token,
              visitId: visitId,
              visitorId: visitorId,
              appId: DOTCOM_UX_ID
            }),
            method: 'PATCH',
            credentials: 'include',
            body: JSON.stringify(actions)
          }, fetchOptions), 'Error modifying carts by filter', {
            pageActionName: 'tread-cart-event'
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function patchCart(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default patchCart;